<div id="banner">
  <img src="/assets/img/showcase/3.jpeg" alt="Banner" class="img-fluid w-100">
</div>